import { axiosApi as axios } from '../helpers/axiosApi';

const MISC_LOCATION_API = '/misc/location/'

export const getAddressSuggestion = (query, googSessionToken) => {
  const params = {'q': query}
  return axios.get(
    MISC_LOCATION_API+'search', {params: params, headers: {'X-SEARCH-SESSION-TOKEN': googSessionToken}},
  ).then(res => res.data);
}

export const getPlaceDetail = (place_id, googSessionToken) => {
  const params = {place_id: place_id}
  return axios.get(
    MISC_LOCATION_API+'detail', {params: params, headers: {'X-SEARCH-SESSION-TOKEN': googSessionToken}},
  ).then(res => res.data);
}
